import React from 'react';
import ModalContainer from './modal-container';
import PropTypes from 'prop-types';
import ModalContent from './modal-content';
import useKeyPress from '../hooks/use-key-press';
import keyConstants from '../utils/keys-constants';

function Modal({
    visible,
    children,
    className,
    onModalDismiss,
    target,
}) {

    const {
        BACKSPACE,
        DEL,
        ESCAPE,
    } = keyConstants;

    const targetKeys = [
        BACKSPACE,
        DEL,
        ESCAPE,
    ];

    const cbObject = {
        cb: onModalDismiss,
    };

    useKeyPress(targetKeys, cbObject);

    return visible ? (
        <ModalContainer target={target}>
            <ModalContent className={className} onClickOutside={ () => onModalDismiss() }>
                { children }
            </ModalContent>
        </ModalContainer>
    ) : null;

}

Modal.propTypes = {
    className: PropTypes.string,
    onModalDismiss: PropTypes.func,
    target: PropTypes.string,
};

Modal.defaultProps = {
    className: '',
    onModalDismiss: () => null,
    target: 'body',
};

export default Modal;
